export default __webpack_public_path__ + "static/media/ACIS-2014.a0685f7c.png";